import { COUNTRY_NAMES } from "@/utils/countries";

export interface CountryOption {
  label: string;
  value: string;
}

/** Full ISO country list for searchable pickers: values are the alpha-2 codes the
 * backend stores, labels the names people search by. */
export function isoCountryOptions(): CountryOption[] {
  return Object.entries(COUNTRY_NAMES)
    .map(([code, name]) => ({ label: `${name} (${code})`, value: code }))
    .sort((a, b) => a.label.localeCompare(b.label));
}

/** Prepend ad-hoc options for codes outside the ISO list (regions like BE-FED, or the
 * XX sentinel from imports), so a picker still displays them instead of a blank. */
export function withUnknownCodes(
  options: CountryOption[],
  codes: (string | null | undefined)[]
): CountryOption[] {
  const unknown = new Set(
    // SECURITY: own-key check — a stored value like "toString" must not resolve
    // through the object prototype and silently vanish from the picker.
    codes.filter(
      (code): code is string => !!code && !Object.hasOwn(COUNTRY_NAMES, code)
    )
  );
  if (unknown.size === 0) return options;
  return [
    ...[...unknown].sort().map((code) => ({ label: code, value: code })),
    ...options,
  ];
}
